import { render, staticRenderFns } from "./agentsale.vue?vue&type=template&id=130c89b7"
import script from "./agentsale.vue?vue&type=script&lang=js"
export * from "./agentsale.vue?vue&type=script&lang=js"
import style0 from "./agentsale.vue?vue&type=style&index=0&id=130c89b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports